import styled from '@emotion/styled';

interface DialogImageProps {
  src: string;
  width: number;
  height: number;
  objectFit?: 'cover' | 'contain' | 'fill';
  alt?: string;
}

export const DialogImage = ({ src, width, height, objectFit = 'cover', alt = '' }: DialogImageProps) => {
  return (
    <Wrapper width={width} height={height}>
      <Image loading='lazy' src={src} alt={alt} objectFit={objectFit} />
    </Wrapper>
  );
};

const Wrapper = styled.div<{ width: number; height: number }>`
  display: inline-block;
  position: relative;
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
  overflow: hidden;
`;

const Image = styled.img<{ objectFit: 'cover' | 'contain' | 'fill' }>`
  width: 100%;
  height: 100%;
  object-fit: ${({ objectFit }) => objectFit};
  display: block;
`;
